var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 撤销会把积分退还用户、同步冲减本店应收与已计佣金。 部分退款按积分比例双向冲正，单据留在「部分退款」，剩余部分继续有效。 超过平台设定的自助撤销时限后这里会被后端拒绝，需走售后退款。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "", placeholder: "全部" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.STATUS, function (text, key) {
                      return _c("el-option", {
                        key: key,
                        attrs: { label: text, value: key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单号" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { clearable: "", placeholder: "核销单号 / 订单号" },
                    model: {
                      value: _vm.query.keyword,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keyword",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "range-separator": "~",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                    },
                    model: {
                      value: _vm.timeRange,
                      callback: function ($$v) {
                        _vm.timeRange = $$v
                      },
                      expression: "timeRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.onSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyNo",
                  label: "核销单号",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(row.type === "ORDER" ? "订单券码" : "积分抵扣")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户 uid", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "bizNo",
                  label: "业务单号",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "订单金额", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.orderAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deductPoints",
                  label: "抵扣积分",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "本店应收", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.receivable)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTagType(row.status),
                            },
                          },
                          [_vm._v(_vm._s(_vm.STATUS[row.status] || row.status))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyTime",
                  label: "核销时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cancelReason",
                  label: "撤销原因",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "90", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.cancelable(row)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openCancel(row)
                                  },
                                },
                              },
                              [_vm._v("撤销")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  layout: _vm.$constants.page.layout,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "撤销核销",
            visible: _vm.dialogVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px",
                size: "small",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "核销单号" } }, [
                _vm._v(_vm._s(_vm.current.verifyNo)),
              ]),
              _c("el-form-item", { attrs: { label: "原抵扣积分" } }, [
                _vm._v(_vm._s(_vm.current.deductPoints)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "撤销方式" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.onModeChange },
                      model: {
                        value: _vm.form.mode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mode", $$v)
                        },
                        expression: "form.mode",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "FULL" } }, [
                        _vm._v("全额撤销"),
                      ]),
                      _c("el-radio", { attrs: { label: "PART" } }, [
                        _vm._v("部分退款"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.mode === "PART"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "退还积分", prop: "refundPoints" } },
                    [
                      _c("el-input-number", {
                        staticClass: "selWidth",
                        attrs: { min: 1, max: _vm.current.deductPoints || 1 },
                        model: {
                          value: _vm.form.refundPoints,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "refundPoints", $$v)
                          },
                          expression: "form.refundPoints",
                        },
                      }),
                      _c("div", { staticClass: "hint" }, [
                        _vm._v(
                          " 应收将按同比例冲减约 " +
                            _vm._s(_vm.yuan(_vm.estimateRefundReceivable())) +
                            "，与积分口径保持一致 "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "撤销原因", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "reason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("确定撤销")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }